import { IPADisplaySettingsModel } from "@/Appointments/Models/UI/IPADisplaySettingsModel";
import { IPAListModel } from "@/Appointments/Models/UI/IPAListModel";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { SettingsButton } from "@/Common/Components/Settings/SettingsButton";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IPAListSettingsContainerProps {
    Model: IPAListModel;
    PADisplaySettingsModel: IPADisplaySettingsModel,
    id?: string;
    className?: string;
    style?: React.CSSProperties;
}

class PAListSettingsContainerState { }

class PAListSettingsContainer extends BaseReactComponent<IPAListSettingsContainerProps, PAListSettingsContainerState> {
    public componentDidMount(): void {
        super.setOverlay("PAListSettingsContainer", { transparent: true });
    }

    public render(): JSX.Element {
        return (
            <div id={this.props.id} className={this.props.className} style={this.props.style}>
                <table className="f-content">
                    <thead>
                        <tr>
                            {this.props.PADisplaySettingsModel.get("Sites").count() > 1 && (
                                <th className="first">
                                    <CheckboxControl
                                        id="sites_check"
                                        label={cacheStore.GetString("SitesLabel")}
                                        operation={LocalOperations.Calendar.PAList_OnSettingsContainerCheckboxChange}
                                        checked={this.props.PADisplaySettingsModel.get("IsAllSitesChecked")}
                                        target={CheckboxTarget.Myle_PAList_SitesControlCheck}
                                    />
                                </th>
                            )}
                            <th>
                                <CheckboxControl
                                    id="clinicians_check"
                                    label={cacheStore.GetString("CliniciansLabel")}
                                    operation={LocalOperations.Calendar.PAList_OnSettingsContainerCheckboxChange}
                                    checked={this.props.PADisplaySettingsModel.get("IsAllEmployeesChecked")}
                                    target={CheckboxTarget.Myle_PAList_CliniciansControlCheck}
                                />
                            </th>
                            <th className="last">
                                <CheckboxControl
                                    id="apt_status_check"
                                    label={cacheStore.GetString("StatusLabel")}
                                    operation={LocalOperations.Calendar.PAList_OnSettingsContainerCheckboxChange}
                                    checked={this.props.PADisplaySettingsModel.get("IsAllStatusChecked")}
                                    target={CheckboxTarget.Myle_PAList_AppointmentStatusControlCheck}
                                />
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {this.props.PADisplaySettingsModel.get("Sites").count() > 1 && (
                                <td className="sites-column">
                                    <div style={{ maxHeight: "400px", minHeight: "400px", overflow: "auto" }}>
                                        <CheckedListControl
                                            DataSource={this.props.PADisplaySettingsModel.get("Sites")}
                                            Operation={LocalOperations.Calendar.PAList_OnSettingsContainerCheckboxChange}
                                        />
                                        <CheckboxControl
                                            id="sites_onlySelected"
                                            label={cacheStore.GetString("ShowOnlySelectedSiteLabel").toUpperCase()}
                                            operation={LocalOperations.Calendar.PAList_OnSettingsContainerCheckboxChange}
                                            checked={this.props.PADisplaySettingsModel.get("IsShowOnlySelectedSitesChecked")}
                                            target={CheckboxTarget.Myle_PAList_OnlySelectedSites}
                                            DivWrap={true}
                                        />
                                    </div>
                                </td>
                            )}
                            <td>
                                <input
                                    className="form-control"
                                    style={{ width: "225px" }}
                                    type="text"
                                    value={this.props.Model.get("CliniciansSearchText")}
                                    onChange={e => this.onCliniciansFilterTextChanged(e)}
                                    placeholder={cacheStore.GetString("SearchLabel").toUpperCase()}
                                />
                                <div style={{ maxHeight: "400px", minHeight: "400px", width: "300px", overflow: "auto" }}>
                                    <CheckedListControl
                                        DataSource={this.props.PADisplaySettingsModel.get("EmployeesFiltered")}
                                        Operation={LocalOperations.Calendar.PAList_OnSettingsContainerCheckboxChange}
                                        sort={true}
                                        limitTextWidth={true}
                                    />
                                </div>
                            </td>
                            <td>
                                <div style={{ maxHeight: "400px", minHeight: "400px", width: "300px", overflow: "auto" }}>
                                    <CheckedListControl
                                        DataSource={this.props.PADisplaySettingsModel.get("AppointmentStatuses")}
                                        Operation={LocalOperations.Calendar.PAList_OnSettingsContainerCheckboxChange}
                                        sort={true}
                                        limitTextWidth={true}
                                    />
                                </div>
                            </td>

                        </tr>
                    </tbody>
                </table>
                <div className="f-footer flex-display flex-space-between">

                    <SettingsButton
                        alternativeIcon={true}
                        onClickOperation={LocalOperations.Calendar.PAList_ColumnOrderingPopup_Open}
                    />

                    <div className="flex-display flex-end flex-gap-xs flex-align-items-center">
                        <CheckboxControl
                            id="saveSettingsChecked"
                            label={cacheStore.GetString("RememberUserSettings")}
                            operation={LocalOperations.Calendar.PAList_SaveSettingsSelected}
                            checked={this.props.Model.get("SaveSettingsChecked")}
                        />
                        <ButtonControl
                            className="btn btn-default"
                            onClick={() => sessionStore.dispatch(LocalOperations.Calendar.PAList_Setting_CancelClick)}
                            label={cacheStore.GetString("CancelLabel")}
                        />
                        <ButtonControl
                            className="btn btn-primary"
                            onClick={() => sessionStore.dispatch(LocalOperations.Calendar.PAList_Setting_OkClick)}
                            label={cacheStore.GetString("Ok_Label")}
                        />
                    </div>
                </div>
            </div>
        );
    }

    public onCliniciansFilterTextChanged(event: React.ChangeEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(LocalOperations.Calendar.PAList_SearchSettings_ClinicianFilterTextChanged);
        operation.AddItem("value", event.target.value);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { PAListSettingsContainer };
